module.exports = __webpack_public_path__ + "files/019f066f45ce4bc9142839d4539bc9ec.svg";